import { ComponentSize, SemanticColor, TagColor, TextColor } from '../../../types';

export enum Icon {
  ARCHIVE = 'archive',
  ARROW_SORT_ASC = 'arrow-sort-ascending',
  ARROW_SORT_DESC = 'arrow-sort-descending',
  ARROW_SORT_NONE = 'arrows-sort-none',
  BAR_CHART = 'bar-chart',
  CHECK = 'check',
  CHEVRON_DOWN = 'chevron-down',
  CHEVRON_LEFT = 'chevron-left',
  CHEVRON_RIGHT = 'chevron-right',
  CHEVRON_UP = 'chevron-up',
  CHEVRONS_UP_DOWN = 'chevrons-up-down',
  CIRCLE_ALERT = 'circle-alert',
  CIRCLE_CHECK = 'circle-check',
  CIRCLE_HELP = 'circle-help',
  CIRCLE_X = 'circle-x',
  CLOSE = 'close',
  COACHING = 'megaphone',
  COMMENT = 'comment',
  COPY = 'copy',
  CORNER_DOWN_LEFT = 'corner-down-left',
  DUPLICATE = 'copy-plus',
  DRAFT = 'pencil-ruler',
  EDIT = 'pencil',
  ELLIPSIS_VERTICAL = 'ellipsis-vertical',
  FAST_FORWARD = 'fastforward',
  FLAG = 'flag',
  FOLDER = 'folder',
  FOLDER_DELETE = 'folder-delete',
  FOLDER_EDIT = 'folder-edit',
  FOLDER_MOVE = 'folder-move',
  FOLDER_OPEN = 'folder-open',
  FOLDER_PLUS = 'folder-plus',
  FOR_YOU = 'for-you',
  GRIP_VERTICAL = 'grip-vertical',
  GONG = 'gong',
  GONG_LIGHT = 'gong-light',
  HIDDEN_GEMS = 'hidden-gems',
  HISTORY = 'history',
  INFO = 'info',
  INTEGRATIONS = 'integrations',
  KNOWLEDGE_HUB = 'knowledge-hub',
  LAPTOP = 'laptop',
  LIBRARY = 'library',
  LINK = 'link',
  LIST_CHECKS = 'list-checks',
  LOCK = 'lock',
  LOG_OUT = 'log-out',
  MAXIMIZE = 'maximize-2',
  MINIMIZE = 'minimize-2',
  MIC_ON = 'mic',
  MIC_OFF = 'mic-off',
  MINUS = 'minus',
  OBJECTIONS = 'objections',
  OPEN = 'open',
  ORIGAMI = 'origami',
  PAUSE = 'pause',
  PHONE = 'phone',
  PHONE_OUTGOING = 'phone-outgoing',
  PLAY = 'play',
  PLUG = 'plug',
  PLUS = 'plus',
  PRIORITIES = 'priorities',
  QUESTIONS = 'questions',
  REPORT = 'report',
  REWIND = 'rewind',
  SCORECARD = 'clipboard-list',
  SEARCH = 'search',
  SEARCH_CHECK = 'search-check',
  SEND = 'send',
  SETTINGS = 'settings',
  SHARE = 'share',
  SPEED = 'speed',
  SQUARE_TERMINAL = 'square-terminal',
  STAR = 'star',
  TABLE_VIEW = 'table-view',
  TAG = 'tag',
  TALLY = 'tally',
  THUMBS_DOWN = 'thumbs-down',
  THUMBS_UP = 'thumbs-up',
  TRASH = 'trash',
  TRIANGLE_ALERT = 'triangle-alert',
  UNARCHIVE = 'unarchive',
  USER = 'user-round',
  USERS = 'users-round',
  USER_PLUS = 'user-round-plus',
  USER_SEARCH = 'user-search',
  WIFI_OFF = 'wifi-off',
  UPLOAD = 'upload',
  TRAFFIC_CONE = 'traffic-cone',
  WAND = 'wand-sparkles',
  ZEUS = 'zeus',
  ARROW_LEFT = 'arrow-left',
  SALESLOFT = 'salesloft',
  SALESLOFT_LIGHT = 'salesloft-light',
}

export type IconColor = SemanticColor | TagColor | TextColor | string;

export interface IconsProps {
  /* Icon to render */
  icon: Icon;
  /* Additional class name */
  className?: string;
  /** Stroke color */
  color?: IconColor;
  disabled?: boolean;
  /** Fill color */
  fillColor?: IconColor;
  /* Icon size */
  size?: ComponentSize | number;
  /* Icon tooltip */
  tooltip?: string;
  /* Icon click handler */
  onClick?: () => void;
  /* Icon hover handler */
  onHover?: (hover: boolean) => void;
  /* Whether to preserve the icon size */
  preserveSize?: boolean;
}

export type IconComponent<T = IconsProps> = React.ReactElement<T>;
